module.exports = __webpack_public_path__ + "static/media/DSC02669.02c49ffd.jpg";